var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-extend-menu-section-component" }, [
    _c("div", { staticClass: "room-extend-menu-section" }, [
      _c("div", { staticClass: "room-extend-menu-section-header" }, [
        _c("button", {
          staticClass: "room-extend-menu-section-button back",
          on: {
            click: function ($event) {
              return _vm.$emit("onChangeSection", "chat")
            },
          },
        }),
        _c("p", { staticClass: "room-extend-menu-section-title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _c("div", { staticClass: "room-extend-menu-section-body" }, [
        _c(
          "div",
          { staticClass: "h-full overflow-y-auto" },
          [
            _c("RoomNotice", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isNoticeSection,
                  expression: "isNoticeSection",
                },
              ],
            }),
            _c("RoomRecord", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isRecordSection,
                  expression: "isRecordSection",
                },
              ],
              attrs: { newWindow: _vm.newWindow },
            }),
            _c("RoomFile", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isFileSection,
                  expression: "isFileSection",
                },
              ],
            }),
            _c("RoomMeetingNote", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isMeetingNoteSection,
                  expression: "isMeetingNoteSection",
                },
              ],
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }